import getIn from 'transmute/getIn';

// Source: https://git.hubteam.com/HubSpot/customer-data-objects/blob/master/static/js/objects/ObjectAccessors.ts
export default function getPropertyValue(properties, propertyName) {
  return getIn([propertyName, 'value'], properties);
}